exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.progress {\n  height: 25px;\n  margin-bottom: 10px;\n}\ninput[type=\"file\"] {\n  width: 100%;\n  border: 0px;\n}\n.mb {\n  margin-bottom: 20px;\n}\n.pb {\n  display: block;\n  padding-bottom: 10px;\n}\n", ""]);

// exports
